import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { confi } from "../assets/index";
import { IoEyeOutline, IoEyeOffOutline } from "react-icons/io5";
import { SlPaperPlane } from "react-icons/sl"; // Changed icon to fit "Request"
import PrivacyPolicy from "./PrivacyPolicy";
import axios from "axios";

const RequestAccess = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [referenceEmail, setReferenceEmail] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [isPPVisible, setPrivacyPolicyVisible] = useState(false);

  const [isLoading, setIsLoading] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);

  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);

    // Create
    // https://api.confidanto.com/shared-project/create
    // {
    //    "reference_email": "user1@gmail.com",
    //   "email": "user12@gmail.com",
    //   "password": "user2@21313"

    // }

    // Get
    // https://api.confidanto.com/shared-project/get
    axios
      .post("https://api.confidanto.com/shared-project/create", {
        email: username,
        password: password,
        reference_email: referenceEmail,
      })
      .then((res) => {
        setIsLoading(false);
        if (res.data) {
          alert("Access request submitted successfully!");
          setUsername("");
          setPassword("");
          setReferenceEmail("");
          // Optional: Navigate to another page after success
          // navigate("/login");
        } else {
          alert("Failed to submit request.");
        }
      })
      .catch((error) => {
        setIsLoading(false);
        if (error.response && error.response.status === 401) {
          setShowErrorModal(true);
        } else {
          alert(error?.response?.data?.message || "An error occurred");
        }
      });
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <>
      <style>
        {`
          body {
            overflow-y: hidden;
            font-family: "Calibri", sans-serif;
          }
        `}
      </style>

      <div className="bg-white md:overflow-auto sm:overflow-y-scroll font-roboto relative">
        <a href="https://www.confidanto.com" rel="noopener noreferrer">
          <img
            src={confi}
            alt="Logo"
            className="h-6 w-32 lg:h-12 lg:w-auto mb-6 mt-8 ml-8"
            style={{ width: "234px", height: "46px" }}
          />
        </a>

        <div className="min-h-screen flex justify-center bg-cover bg-center bg-transparent w-full">
          {/* Container size adjusted to max-w-md since we removed the 2-column layout */}
          <div className="max-w-md w-full bg-white bg-opacity-75 rounded-lg p-8 mx-4">
            <h2 className="mt-2 text-center text-4xl lg:text-5xl font-bold text-gray-900">
              Request Access
            </h2>

            <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
              <div className="w-full items-center flex flex-col space-y-2">
                {/* Username Input */}
                <div className="relative w-full">
                  <input
                    id="username"
                    name="username"
                    type="email"
                    autoComplete="username"
                    required
                    className="block px-2.5 pb-2.5 pt-5 w-full text-sm lg:text-base text-gray-900 bg-transparent dark:bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                    placeholder=" "
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                  />
                  <label
                    htmlFor="username"
                    className="absolute text-sm lg:text-base text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-4 z-10 origin-[0] start-2.5 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto"
                  >
                    Email
                  </label>
                </div>

                {/* Password Input */}
                <div className="relative w-full mt-4">
                  <input
                    id="password"
                    name="password"
                    type={showPassword ? "text" : "password"}
                    autoComplete="new-password"
                    required
                    className="block px-2.5 pb-2.5 pt-5 w-full text-sm lg:text-base text-gray-900 bg-transparent dark:bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                    placeholder=" "
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                  <label
                    htmlFor="password"
                    className="absolute text-sm lg:text-base text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-4 z-10 origin-[0] start-2.5 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto"
                  >
                    Password
                  </label>
                  <button
                    type="button"
                    className="absolute top-5 right-4 focus:outline-none text-xl text-gray-500 hover:text-gray-700"
                    onClick={togglePasswordVisibility}
                  >
                    {showPassword ? <IoEyeOffOutline /> : <IoEyeOutline />}
                  </button>
                </div>

                {/* Reference/Owner Mail Input */}
                <div className="relative w-full mt-4">
                  <input
                    id="referenceEmail"
                    name="referenceEmail"
                    type="email"
                    autoComplete="email"
                    required
                    className="block px-2.5 pb-2.5 pt-5 w-full text-sm lg:text-base text-gray-900 bg-transparent dark:bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                    placeholder=" "
                    value={referenceEmail}
                    onChange={(e) => setReferenceEmail(e.target.value)}
                  />
                  <label
                    htmlFor="referenceEmail"
                    className="absolute text-sm lg:text-base text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-4 z-10 origin-[0] start-2.5 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto"
                  >
                    Reference / Owner Mail
                  </label>
                </div>

                <div className="w-full mt-12 pt-4">
                  {/* ADDED LOGIN LINK TEXT HERE */}
                  <p className="text-sm text-gray-500 text-center mb-4">
                    Already have an account?{" "}
                    <Link
                      to="/login"
                      className="text-blue-600 hover:text-blue-800 hover:underline font-medium transition-colors"
                    >
                      Log in
                    </Link>
                  </p>

                  <button
                    type="submit"
                    className="group relative w-full text-[#0f62e6] items-center flex justify-center py-2.5 px-4 border border-[#0f62e6] text-sm lg:text-base font-medium rounded-full hover:text-white bg-transparent hover:bg-[#0f62e6] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors duration-300"
                  >
                    Request Access
                    <span className="ml-4">
                      <SlPaperPlane />
                    </span>
                  </button>
                </div>
              </div>
            </form>

            <div className="flex flex-col items-center justify-center text-xs text-gray-500 mt-8 space-y-1">
              <div className="flex space-x-2">
                <span className="cursor-pointer hover:text-blue-600">
                  Terms of Use
                </span>
                <span>|</span>
                <button
                  type="button"
                  onClick={(e) => setPrivacyPolicyVisible(true)}
                  className="hover:text-blue-600 focus:outline-none"
                >
                  Privacy Policy
                </button>
              </div>
              <p>Policy and Terms of Service apply.</p>
            </div>
          </div>
        </div>

        {/* Global Loader - Increased z-index to [60] so it overlays the modals */}
        {isLoading && (
          <div className="fixed inset-0 flex items-center justify-center bg-white bg-opacity-70 backdrop-blur-sm z-[60]">
            <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-600"></div>
          </div>
        )}

        {/* Error Modal */}
        {showErrorModal && (
          <div
            className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm z-50 transition-opacity p-4"
            onClick={() => setShowErrorModal(false)}
          >
            <div
              className="bg-white rounded-xl shadow-2xl p-6 md:p-8 max-w-[550px] w-full flex items-start space-x-5 transform transition-all"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="flex-shrink-0 mt-1">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="#f59e0b"
                  className="w-8 h-8"
                >
                  <path
                    fillRule="evenodd"
                    d="M9.401 3.003c1.155-2 4.043-2 5.197 0l7.355 12.748c1.154 2-.29 4.5-2.599 4.5H4.645c-2.309 0-3.752-2.5-2.598-4.5L9.4 3.003zM12 8.25a.75.75 0 01.75.75v3.75a.75.75 0 01-1.5 0V9a.75.75 0 01.75-.75zm0 8.25a1 1 0 100-2 1 1 0 000 2z"
                    clipRule="evenodd"
                  />
                </svg>
              </div>
              <div className="flex flex-col space-y-4">
                <h3 className="text-xl font-bold text-gray-900 tracking-tight">
                  Request Failed
                </h3>
                <p className="text-gray-600 text-[15px] leading-relaxed">
                  We could not submit your access request. Please check the
                  details you provided and ensure your Reference/Owner Email is
                  correct.
                </p>
                <button
                  onClick={() => setShowErrorModal(false)}
                  className="text-blue-600 font-semibold text-left hover:text-blue-800 transition-colors w-fit p-0 m-0 border-none bg-transparent underline underline-offset-4"
                >
                  Try Again
                </button>
                <div className="pt-2 mt-2 border-t border-gray-100">
                  <p className="text-sm text-gray-500 leading-relaxed pt-2">
                    If you're still experiencing issues, please contact your
                    local administrator or Client Success Manager.
                  </p>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Privacy Policy Modal */}
        {isPPVisible && (
          <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50 p-8">
            <div className="bg-white rounded-lg w-full md:w-3/6 relative max-h-screen overflow-y-auto">
              <PrivacyPolicy onClose={() => setPrivacyPolicyVisible(false)} />
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default RequestAccess;
